import { useEffect, useRef, useState } from 'react'
import { labeledXAxis, labeledYAxis } from './helpers/labeledAxes';
import { chartTheme } from './helpers/chartTheme';
import { marginConvention } from './helpers/marginConvention'
import { select, scaleLinear, curveBasis, line, axisLeft, axisBottom, max, min } from 'd3';
import AnalysisExport from '../components/AnalysisExport';

function debounce(fn, ms) {
    let timer
    return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
            timer = null
            fn.apply(this, arguments)
        }, ms)
    };
}

const DecelerationVsSpeed = (props) => {
    const [decelSpeedData, setDecelSpeedData] = useState(props.data)
    const svgRef = useRef()

    useEffect(() => {
        if (decelSpeedData?.length === 0 || decelSpeedData === null) return
        // const totalElapsedTime = speedTimeData[speedTimeData.length-1].et

        function responsiveComponent(svg, props) {
            const { width, height, margin } = props;

            svg = svg.enter().append('svg')
                .merge(svg)
                .attr('width', width)
                .attr('height', height);

            const { g, innerWidth, innerHeight } = marginConvention(svg, { width, height, margin });

            const xMax = max(decelSpeedData.map((item) => item.speed))

            const xScale = scaleLinear()
                .domain([xMax, 0])
                .range([0, innerWidth])
                .nice();

            labeledXAxis(g, Object.assign({}, props, {
                xScale,
                innerWidth,
                innerHeight
            }));

            const yMin = min(decelSpeedData.map((item) => item.deceleration))
            const yMax = max(decelSpeedData.map((item) => item.deceleration))

            const yScale = scaleLinear()
                .domain([0, 1])
                .range([innerHeight, 0])
                .nice();

            labeledYAxis(g, Object.assign({}, props, {
                yScale,
                innerHeight
            }));
       
            // gridlines in x axis function
            function make_x_gridlines() {		
                return axisBottom(xScale)
                    .ticks()
            }

            // gridlines in y axis function
            function make_y_gridlines() {		
                return axisLeft(yScale)
                    .ticks()
            }

            // add the X gridlines
            g.selectAll('.xgrid').remove()
            g.append("g")
            .attr("class", "xgrid")
            .attr("transform", "translate(0," + innerHeight + ")")
            .call(make_x_gridlines()
                .tickSize(-innerHeight)
                .tickFormat("")
            )

            // add the Y gridlines
            g.selectAll('.ygrid').remove()
            g.append("g")			
            .attr("class", "ygrid")
            .call(make_y_gridlines()
                .tickSize(-innerWidth)
                .tickFormat("")
            )

            // Title
            const mainTitle = g.selectAll('.main-title').data([null])
            mainTitle
                .enter().append("text")
                .attr('class', 'main-title')
            .merge(mainTitle)
                .attr('fill', chartTheme.titleFill)
                .attr("x", (innerWidth / 2))             
                .attr("y", margin.top + 45)
                .attr("text-anchor", "middle")  
                .style("font-size", "26px") 
                .text("Deceleration vs. Speed");

            // plot the line
            const lineGenerator = line()
                .x((value, index) => xScale(value.speed))
                .y((value, index) => yScale(value.deceleration))
                .curve(curveBasis)

            g.selectAll('.line')
                .data([decelSpeedData])
                .join('path')
                .attr('class', 'line')
                .attr('d', value => lineGenerator(value))
                .attr('fill', 'none')
                .attr('stroke', 'steelblue')
                .attr('stroke-width', '1')

            // draw the points
            g.selectAll('.dots')
                .data(decelSpeedData)
                .join("circle")
                .attr('class', 'dots')
                .attr('stroke','steelblue')
                .attr('r','2')
                .attr('fill','steelblue')
                .attr('cx', (d) => xScale(d.speed))
                .attr('cy', (d) => yScale(d.deceleration))

        }

        const RenderChart = () => {
            const svg = select(svgRef.current)

            if (decelSpeedData !== null) {
                responsiveComponent(svg, Object.assign({}, chartTheme, {
                    width: window.innerWidth-20,
                    height: 600,
                    margin: { top: 20, bottom: 71, left: 100, right: 30 },
                    xAxisLabel: 'Speed (knots)',
                    yAxisLabel: 'Deceleration (g)'
                }));
            }
        }

        const debouncedHandleResize = debounce(function handleResize() {
            RenderChart()
        }, 500)

        window.addEventListener('resize', debouncedHandleResize)

        RenderChart()

        return _ => {
            window.removeEventListener('resize', debouncedHandleResize)
        }
    }, [])

    return ( 
        <>
            <AnalysisExport name={"Deceleration Vs. Speed"} data={decelSpeedData} />
            <svg ref={svgRef}></svg>
        </>
    );
}

export default DecelerationVsSpeed;
